import { useSelector } from "react-redux";

/**
 * Resumo da sacola para a barra flutuante e para decidir se ela aparece.
 * `itemsCount` conta unidades; produto por quilo conta como 1.
 */
export default function useCartSummary() {
  const isAvailableToOrder = useSelector(
    (state) => state.shop.isAvailableToOrder,
  );
  const productOrders = useSelector(
    (state) => state.shoppingCart.productOrders,
  );
  const total = useSelector((state) => state.shoppingCart.cachedTotalCosts);

  const commitedOrders = productOrders.filter((o) => o.commited);
  const itemsCount = commitedOrders.reduce(
    (count, order) => count + (order.product?.isKilogram ? 1 : order.qtt),
    0,
  );

  return {
    commitedOrders,
    itemsCount,
    total,
    isVisible: isAvailableToOrder && commitedOrders.length > 0,
  };
}
